import Swiper from "swiper/bundle"
export default class CarouselGalleryAuto {
    constructor() {
        this.carousel = {
            element: document.querySelector(
                '.carousel[data-carousel="gallery-auto"]'
            ),
        }

        this.createCarousel(this.carousel.element) // Init Carousel
    }

    createCarousel(target) {
        this.carousel.controls = target.querySelector(".controls")
        
        let config = {
            slidesPerView: "auto",
            spaceBetween: 10,
            grabCursor: true,
            centeredSlides: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                draggable: true,
            },
            breakpoints: {
                768: {
                    spaceBetween: 40,
                    centeredSlides: false,
                },
            },
        }

        if(this.carousel?.controls){
            config.navigation = {
                nextEl: this.carousel.controls.querySelector("[data-next]"),
                prevEl: this.carousel.controls.querySelector("[data-prev]"),
                clickable: true,
            }
        }

        let carousel = new Swiper(target, config)

        if(!!target && target.querySelectorAll('.swiper-slide').length > 3){
            target.setAttribute('data-draggable',true)
        }
    }
}
